export const GET_STORE_EMAILS_START = 'GET_STORE_EMAILS_START';
export const GET_STORE_EMAILS_SUCCESS = 'GET_STORE_EMAILS_SUCCESS';
export const GET_STORE_EMAILS_FAILED = 'GET_STORE_EMAILS_FAILED';

export const UPDATE_STORE_EMAILS_DATA_START = 'UPDATE_STORE_EMAILS_DATA_START';
export const UPDATE_STORE_EMAILS_DATA_SUCCESS = 'UPDATE_STORE_EMAILS_DATA_SUCCESS';
export const UPDATE_STORE_EMAILS_DATA_FAILED = 'UPDATE_STORE_EMAILS_DATA_FAILED';

export const getStoreEmailsStart = () => ({
  type: GET_STORE_EMAILS_START
});

export const getStoreEmailsSuccess = (data) => ({
  type: GET_STORE_EMAILS_SUCCESS,
  data
});

export const getStoreEmailsFailed = () => ({
  type: GET_STORE_EMAILS_FAILED
});

export const updateStoreEmailsStart = () => ({
  type: UPDATE_STORE_EMAILS_DATA_START
});

export const updateStoreEmailsSuccess = (data) => ({
  type: UPDATE_STORE_EMAILS_DATA_SUCCESS,
  data
});

export const updateStoreEmailsFailed = () => ({
  type: UPDATE_STORE_EMAILS_DATA_FAILED
});
